import React from 'react';
import { Button } from '../ui/button';
import { ShieldCheck, SpinnerGap, User, CalendarBlank, IdentificationCard, Globe } from '@phosphor-icons/react';
import { TemplateSelector, FormField, DateField, HistoryList, HistoryPanel } from './FormFields';

export const VerificationTab = ({
  verificationTemplates, selectedVerificationTemplateId, setSelectedVerificationTemplateId,
  verificationForm, setVerificationForm, isGeneratingVerification, isAdmin,
  verifications, loadingVerifications,
  onGenerate, onDownload, onDelete
}) => (
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
    <div className="lg:col-span-2">
      <div className="border border-[#262626] bg-[#141414]">
        <div className="p-4 border-b border-[#262626]">
          <h2 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#A3A3A3]">Данные кандидата</h2>
          <p className="text-xs text-[#525252] mt-1">Case ID / Reference Number генерируются автоматически</p>
        </div>
        <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <TemplateSelector templates={verificationTemplates} selectedId={selectedVerificationTemplateId}
              onSelect={setSelectedVerificationTemplateId} testId="verification-template-select" isAdmin={isAdmin} />
          </div>
          <FormField icon={User} label="ФИО кандидата" value={verificationForm.fullName}
            onChange={(v) => setVerificationForm(p => ({...p, fullName: v}))} placeholder="IVANOV IVAN" testId="verification-name-input" />
          <FormField icon={CalendarBlank} label="Дата рождения" value={verificationForm.dateOfBirth}
            onChange={(v) => setVerificationForm(p => ({...p, dateOfBirth: v}))} placeholder="01.01.2000" testId="verification-dob-input" />
          <FormField icon={IdentificationCard} label="Паспорт / ID" value={verificationForm.passportId}
            onChange={(v) => setVerificationForm(p => ({...p, passportId: v}))} placeholder="AA1234567" testId="verification-passport-input" />
          <FormField icon={Globe} label="Национальность" value={verificationForm.nationality}
            onChange={(v) => setVerificationForm(p => ({...p, nationality: v}))} placeholder="UZBEKISTAN" testId="verification-nationality-input" />
          <div className="md:col-span-2">
            <DateField label="Дата документа / Review date"
              date={verificationForm.documentDate}
              onDateChange={(d) => setVerificationForm(p => ({...p, documentDate: d}))} testId="verification-date-picker" />
          </div>
        </div>
        <div className="p-4 border-t border-[#262626]">
          <Button onClick={onGenerate} disabled={isGeneratingVerification || !selectedVerificationTemplateId}
            className="w-full h-12 bg-[#FACC15] hover:bg-[#EAB308] text-[#0A0A0A] font-semibold rounded-none disabled:opacity-50"
            data-testid="generate-verification-btn">
            {isGeneratingVerification ? <><SpinnerGap size={20} className="animate-spin mr-2" />Генерация...</>
              : <><ShieldCheck size={20} className="mr-2" weight="bold" />Создать верификацию</>}
          </Button>
        </div>
      </div>
    </div>
    <HistoryPanel title="История" count={verifications.length}>
      <HistoryList items={verifications} loading={loadingVerifications}
        onDownload={onDownload} onDelete={onDelete}
        subtitleField="case_id" testPrefix="verification-item" />
    </HistoryPanel>
  </div>
);
